<template>
  <div id="contenidor_appheader">
    <div id="top_info" class="w3-contanier w3-row" v-if="isAuthenticated">
      <div class="pageTitle">
        <transition name="fade" mode="out-in">
          <h1 id="titol_pagina" :key="contentName">{{ contentName }}</h1>
        </transition>
      </div>
      <div class="info">
        <div class="info-header">
          <div id="dades_usuari">
            <div>
              <p v-if="isProfileLoaded" v-text="$ml.get('myMessage')">  </p>
              <p v-on:click="logout" style="cursor: pointer"> {{ $ml.get('closeSession') }} </p>
            </div>
            <div>
              <div id="ide_usuari" class="w3-circle">
                <p> {{ name | lletraUsuari }} </p>
              </div>
            </div>
          </div>
          <div class="errors">
            <transition name="fade" mode="out-in">
              <span v-if="authStatus === '403'" class="formErrors">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error403') }}.
              </span>
              <span v-else-if="authStatus === '404'" class="formErrors">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error404') }}.
              </span>
              <span v-else-if="authStatus && authStatus !== 'success' && authStatus !== 'loading'" class="formErrors">
                <i class="sherpa-icon icon-ico_error"></i> {{ $ml.get('error500header') }}.
              </span>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <!-- SUBMENU OPTIONS -->
    <actions-header />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ActionsHeader from '@/components/appHeader/actionsHeader'
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import * as userTypes from '@/store/actions/user'
import { MLBuilder } from 'vue-multilanguage'

export default {
  name: 'app-header',
  data () {
    return {
    }
  },
  components: {
    ActionsHeader
  },
  methods: {
    logout () {
      this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_LOGOUT}`).then(() => {
        this.$router.push('/login').catch(() => {})
        this.$store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
      })
    }
  },
  computed: {
    ...mapGetters(`${userTypes.USER_NAMESPACE}`, [`${userTypes.USER_PROFILE}`, `${userTypes.USER_PROFILE_LOADED}`]),
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`, `${authTypes.AUTH_STATUS}`]),
    ...mapState({
      authLoading: state => state.auth.status === 'loading',
      gender: state => `${state.user.gender}`,
      name: state => `${state.user.name}`,
      contentName (state) {
        var result = ''
        if (state.app.currentContent.name) {
          result = `${state.app.currentContent.name}`
        }
        return result
      },
      mlmyMessage (state) {
        return new MLBuilder('welcome' + state.user.gender).with('name', state.user.name)
      }
    })
  },
  filters: {
    lletraUsuari (value) {
      return value.substring(0, 1).toUpperCase()
    }
  }
}
</script>

<style lang="scss">
  #content #contenidor_appheader {
    top: 0;
    right: 0;
    left: 350px;
    background: white;
    z-index: 999;

    #top_info {
      height: 90px;

      .pageTitle {
        float: left;

        #titol_pagina {
          font-family: Capriola;
          font-size: 24px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #342d38;
          margin-top: 30px;
        }
      }

      .info {
        float: right;

        .info-header {
          padding-top: 15px;

          .errors {
            float: right;
            margin-right: 30px;

            .formErrors {
              margin-top: 0;
            }
          }

          #dades_usuari {
            float: right;
            margin-right: 16px;

            >div {
              display: inline-block;

              p {
                font-family: Barlow;
                font-size: 16px;
                font-weight: 300;
                font-style: normal;
                font-stretch: normal;
                line-height: 0.1;
                letter-spacing: normal;
                text-align: right;
                color: #342d38;
              }

              p:last-of-type {
                font-family: Capriola;
                font-weight: normal;
                color: #ff7643;
                font-size: 12px;
              }

              #ide_usuari {
                position: relative;
                margin-left: 10px;
                width: 40px;
                height: 40px;
                background-color: #4599a4;
                margin-top: 5px;

                p {
                  position: absolute;
                  left: 12px;
                  top: -6px;
                  font-family: Barlow;
                  font-size: 24px;
                  font-weight: 600;
                  font-style: normal;
                  font-stretch: normal;
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/appHeader/index.vue